import * as apiKey from './api-key'
import * as appAction from './app-action'
import * as appActionCall from './app-action-call'
import * as appBundle from './app-bundle'
import * as appDefinition from './app-definition'
import * as appDetails from './app-details'
import * as appInstallation from './app-installation'
import * as appSignedRequest from './app-signed-request'
import * as appSigningSecret from './app-signing-secret'
import * as appUpload from './app-upload'
import * as asset from './asset'
import * as assetKey from './asset-key'
import * as bulkAction from './bulk-action'
import * as comment from './comment'
import * as contentType from './content-type'
import * as editorInterface from './editor-interface'
import * as entry from './entry'
import * as environment from './environment'
import * as environmentAlias from './environment-alias'
import * as environmentTemplate from './environment-template'
import * as environmentTemplateInstallation from './environment-template-installation'
import * as extension from './extension'
import * as locale from './locale'
import * as organization from './organization'
import * as organizationInvitation from './organization-invitation'
import * as organizationMembership from './organization-membership'
import * as personalAccessToken from './personal-access-token'
import * as accessToken from './access-token'
import * as previewApiKey from './preview-api-key'
import * as release from './release'
import * as releaseAction from './release-action'
import * as role from './role'
import * as scheduledAction from './scheduled-action'
import * as snapshot from './snapshot'
import * as space from './space'
import * as spaceMember from './space-member'
import * as spaceMembership from './space-membership'
import * as tag from './tag'
import * as task from './task'
import * as team from './team'
import * as teamMembership from './team-membership'
import * as teamSpaceMembership from './team-space-membership'
import * as uiConfig from './ui-config'
import * as upload from './upload'
import * as usage from './usage'
import * as user from './user'
import * as userUIConfig from './user-ui-config'
import * as webhook from './webhook'
import * as workflowDefinition from './workflow-definition'

export default {
  accessToken,
  appAction,
  appActionCall,
  appBundle,
  apiKey,
  appDefinition,
  appInstallation,
  appUpload,
  appDetails,
  appSignedRequest,
  appSigningSecret,
  asset,
  assetKey,
  bulkAction,
  comment,
  contentType,
  editorInterface,
  entry,
  environment,
  environmentAlias,
  environmentTemplate,
  environmentTemplateInstallation,
  extension,
  locale,
  organization,
  organizationInvitation,
  organizationMembership,
  personalAccessToken,
  previewApiKey,
  release,
  releaseAction,
  role,
  scheduledAction,
  snapshot,
  space,
  spaceMember,
  spaceMembership,
  tag,
  task,
  team,
  teamMembership,
  teamSpaceMembership,
  uiConfig,
  upload,
  usage,
  user,
  userUIConfig,
  webhook,
  workflowDefinition,
}
